import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'GlobalSelection',
  components: {
    GlobalTitle: GlobalTitle,
    MdmLink: MdmLink
  },
  props: {
    url: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    title: {
      type: Object,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    cta: {
      type: String,
      default: ''
    }
  }
};